var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 406,
    viewBox: "0 0 455 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.187 227.392L176.833 204.366C176.833 204.366 174.843 202.56 170.618 199.079C166.394 195.599 162.49 191.956 147.602 191.956C136.963 191.956 110.298 190.102 101.967 190.102C96.7294 190.234 91.6702 192.048 87.524 195.28L76.8431 204.366L30.4894 227.392L4.71245 310.829L1.26596 337.258C0.541706 342.823 1.30305 348.483 3.4716 353.652C5.64015 358.82 9.13696 363.311 13.6008 366.659C45.7998 390.78 84.6488 404.169 124.741 404.965C164.833 405.761 204.173 393.922 237.287 371.098C241.877 367.947 245.555 363.621 247.945 358.565C250.336 353.508 251.353 347.902 250.892 342.319L248.965 319.567L223.187 227.392Z",
    fill: "#F9EED5",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.643 115.01C160.744 115.01 185.146 90.3835 185.146 60.0051C185.146 29.6266 160.744 5 130.643 5C100.542 5 76.1406 29.6266 76.1406 60.0051C76.1406 90.3835 100.542 115.01 130.643 115.01Z",
    fill: "#572E0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.64 15.1875C94.8554 20.9332 86.7941 36.6555 84.3957 46.9376C81.9973 57.2198 83.5377 68.1406 84.4733 78.6624",
    stroke: "#AF7029",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.247 11.1992C102.81 22.2744 96.132 43.4123 96.465 60.1479",
    stroke: "#AF7029",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.298 9.72266C119.533 25.1718 117.65 44.4111 117.664 60.3202",
    stroke: "#AF7029",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.747 8.89844C132.218 24.3007 131.897 40.3266 127.812 55.5748",
    stroke: "#AF7029",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.258 8.17969C143.498 19.9341 151.459 37.9053 154.567 53.2407",
    stroke: "#AF7029",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.883 8.80078C148.097 13.5677 156.355 23.195 161.731 32.1258C167.107 41.0566 172.522 55.5716 172.522 65.8203",
    stroke: "#AF7029",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.195 11.5C161.045 16.862 169.29 24.7906 175.073 34.4605C180.807 44.0827 186.27 68.1946 175.619 82.1938",
    stroke: "#AF7029",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.592 268.069C201.418 266.302 203.388 259.468 200.993 252.804C198.598 246.14 192.744 242.171 187.918 243.938C183.092 245.704 181.121 252.539 183.517 259.202C185.912 265.866 191.766 269.836 196.592 268.069Z",
    fill: "white",
    stroke: "#B9BBBD",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.771 261.933C201.923 260.779 203.21 256.316 201.645 251.963C200.081 247.611 196.258 245.018 193.106 246.172C189.954 247.326 188.667 251.79 190.231 256.142C191.796 260.495 195.619 263.087 198.771 261.933Z",
    fill: "#201046",
    stroke: "#201046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9766 233.98C84.367 182.67 95.297 179.152 129.144 179.152C162.992 179.152 181.364 189.976 197.541 253.448",
    stroke: "#201046",
    strokeWidth: 1.432,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1302 295.888C64.7097 294.434 65.5763 292.797 65.0659 292.233C64.5555 291.668 62.8613 292.389 61.2818 293.843C59.7023 295.298 58.8356 296.934 59.346 297.499C59.8565 298.064 61.5507 297.342 63.1302 295.888Z",
    fill: "#B9BBBD",
    stroke: "#B9BBBD",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2296 292.465C43.0717 290.651 41.6139 289.52 40.9801 289.926C40.3463 290.332 36.5854 294.628 37.7434 296.442C38.9013 298.255 44.5375 296.909 45.1733 296.494C45.8091 296.08 45.3876 294.283 44.2296 292.465Z",
    fill: "#201046",
    stroke: "#B9BBBD",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.283 294.163C59.7186 295.634 58.8687 297.28 59.3858 297.839C59.9029 298.399 64.7488 301.372 66.3132 299.9C67.8776 298.429 65.5658 293.07 65.0497 292.511C64.5336 291.952 62.8464 292.692 61.283 294.163Z",
    fill: "#201046",
    stroke: "#B9BBBD",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5601 294.134C61.5601 294.134 39.1785 268.908 45.262 247.699C48.4713 236.507 57.9475 231.438 67.9727 233.98C77.9979 236.518 83.9504 245.384 81.5671 256.898C77.3558 277.246 43.9922 292.656 43.9922 292.656",
    stroke: "#201046",
    strokeWidth: 1.432,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M179.78 126.156C193.941 81.4057 173.871 37.1356 133.841 35.4877C93.8115 33.8399 67.5429 76.4164 80.7221 122.073L179.78 126.156Z",
    fill: "#572E0F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9897 128.322C93.7553 119.738 88.3979 113.664 80.7721 116.283C70.1372 119.938 73.7588 137.925 78.4319 144.915C82.8514 151.53 90.6648 150.093 92.6879 143.728",
    fill: "#FAD082"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9897 128.322C93.7553 119.738 88.3979 113.664 80.7721 116.283C70.1372 119.938 73.7588 137.925 78.4319 144.915C82.8514 151.53 90.6648 150.093 92.6879 143.728",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M166.055 131.303C166.984 122.767 172.814 117.156 180.202 120.393C190.507 124.91 185.441 142.541 180.218 149.127C175.279 155.355 167.609 153.282 166.107 146.769",
    fill: "#FAD082"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.055 131.303C166.984 122.767 172.814 117.156 180.202 120.393C190.507 124.91 185.441 142.541 180.218 149.127C175.279 155.355 167.609 153.282 166.107 146.769",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M173.468 75.9774L132.27 74.2778L91.0732 72.5781C84.7351 83.8269 82.4209 129.153 86.098 145.79C89.3596 160.546 92.5578 171.893 103.327 180.514L99.2694 219.458C99.2694 229.239 111.964 237.169 127.624 237.169C143.284 237.169 155.979 229.239 155.979 219.458L152.156 182.789C163.868 175.073 168.012 163.942 172.504 149.351C177.516 133.076 178.876 87.7105 173.468 75.9774Z",
    fill: "#FAD082"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.676 95.5137C110.419 94.1887 102.055 96.2092 98.1797 101.208",
    stroke: "#1F1046",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.406 95.5137C151.663 94.1887 160.027 96.2092 163.903 101.208",
    stroke: "#1F1046",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M151.423 112.868C152.58 112.868 153.517 111.922 153.517 110.755C153.517 109.587 152.58 108.641 151.423 108.641C150.266 108.641 149.328 109.587 149.328 110.755C149.328 111.922 150.266 112.868 151.423 112.868Z",
    fill: "#1F1046"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.657 111.595C111.814 111.595 112.752 110.649 112.752 109.481C112.752 108.314 111.814 107.367 110.657 107.367C109.5 107.367 108.562 108.314 108.562 109.481C108.562 110.649 109.5 111.595 110.657 111.595Z",
    fill: "#1F1046"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.901 129.477C123.085 131.03 121.069 133.371 122.009 133.895C124.602 135.896 127.743 137.041 131.005 137.175C134.266 137.31 137.489 136.427 140.236 134.647C140.739 134.183 139.355 132.671 139.733 131.084",
    stroke: "#1F1046",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9349 128.184C84.4399 133.916 80.3984 136.382 80.3984 136.382",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2919 133.151C81.0471 132.599 79.6751 132.406 78.3281 132.593",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M179.082 132.234C175.125 137.658 178.953 140.45 178.953 140.45",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M177.312 137.324C178.598 136.877 179.981 136.797 181.309 137.094",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177.303 61.375C180.623 75.5702 165.578 96.5559 137.72 85.7427C125.317 80.9281 115.164 73.8168 101.731 75.421C90.664 76.7409 87.329 86.0179 85.3631 92.4865C85.3631 92.4865 83.2506 91.4092 83.469 82.8724C83.6873 74.3356 89.5976 62.0746 89.5976 62.0746",
    fill: "#572E0F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M139.526 154.844C136.131 158.887 125.458 158.373 122.578 154.953",
    stroke: "#1F1046",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M125.133 287.879L139.494 324.611L139.453 404.559",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M132.27 325.557C132.27 328.593 129.832 331.047 126.834 331.047C123.836 331.047 121.398 328.593 121.398 325.557C121.398 322.52 123.836 320.066 126.834 320.066C129.832 320.066 132.27 322.52 132.27 325.557Z",
    stroke: "#1F1046"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132.27 358.717C132.27 361.754 129.832 364.207 126.834 364.207C123.836 364.207 121.398 361.754 121.398 358.717C121.398 355.68 123.836 353.227 126.834 353.227C129.832 353.227 132.27 355.68 132.27 358.717Z",
    stroke: "#1F1046"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M132.27 391.877C132.27 394.914 129.832 397.368 126.834 397.368C123.836 397.368 121.398 394.914 121.398 391.877C121.398 388.841 123.836 386.387 126.834 386.387C129.832 386.387 132.27 388.841 132.27 391.877Z",
    stroke: "#1F1046"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M107.828 183.688C114.066 187.546 122.242 188.764 127.623 188.987C133.005 189.211 141.255 188.669 147.781 185.332",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M153.822 198.766C154.842 214.01 126.838 227.39 126.838 227.39C126.838 227.39 101.205 210.434 101.205 200.89L92.7812 209.762C92.7812 209.762 124.311 287.602 125.132 287.878C125.953 288.155 162.668 208.352 162.668 208.352L153.822 198.766Z",
    fill: "#098B8C",
    stroke: "#1F1046",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M126.836 227.391C133.542 231.763 141.251 236.345 147.943 240.194",
    stroke: "#1F1046",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3057 320.105L30.1406 377.555",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M210.5 324.25L220.665 381.7",
    stroke: "#1F1046",
    strokeWidth: 0.477,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 117,
    r: 117,
    fill: "#399F28"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 46,
    width: 118.506,
    height: 141.605,
    rx: 5,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 291.055,
    y1: 65.0938,
    x2: 346.291,
    y2: 65.0938,
    stroke: "#399F28",
    strokeWidth: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 291.055,
    y1: 85.1797,
    x2: 378.428,
    y2: 85.1797,
    stroke: "#399F28",
    strokeWidth: 6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 291.055,
    y1: 98.2344,
    x2: 378.428,
    y2: 98.2344,
    stroke: "#399F28",
    strokeWidth: 6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 291.055,
    y1: 113.297,
    x2: 378.428,
    y2: 113.297,
    stroke: "#399F28",
    strokeWidth: 6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 291.055,
    y1: 142.422,
    x2: 378.428,
    y2: 142.422,
    stroke: "#399F28",
    strokeWidth: 6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 291.055,
    y1: 153.469,
    x2: 378.428,
    y2: 153.469,
    stroke: "#399F28",
    strokeWidth: 6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 291.055,
    y1: 166.527,
    x2: 363.364,
    y2: 166.527,
    stroke: "#399F28",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorReport);
export default __webpack_public_path__ + "static/media/doctorReport.37f2a9ebc5a9254bc3d8e8cf4ac6ab24.svg";
export { ForwardRef as ReactComponent };